<app-question-template [form]="form" [question]="question">
	<div class="file-question">
		@if (!hasFile) {
			<button
				type="button"
				class="file-question-dropzone"
				[class.file-question-dropzone-busy]="uploadBusy"
				[disabled]="uploadBusy"
				(click)="onDropzoneActivate(fileInput)"
			>
				@if (uploadBusy) {
					<div class="file-question-overlay">
						<ion-spinner name="crescent" aria-hidden="true"></ion-spinner>

						<span class="file-question-overlay-status">{{ "FILE_QUESTION__UPLOADING" | transloco }}</span>
					</div>
				} @else {
					<div class="file-question-dropzone-inner">
						<ion-icon name="document-outline" aria-hidden="true"></ion-icon>

						<span class="file-question-select-label">{{ "FILE_QUESTION__SELECT_FILE" | transloco }}</span>
					</div>
				}
			</button>
			@if (!uploadBusy) {
				<span class="file-question-size-hint">{{ "FILE_QUESTION__MAX_SIZE_HINT" | transloco }}</span>
			}
		} @else {
			<div class="file-question-selected" [class.file-question-selected-busy]="uploadBusy">
				@if (uploadBusy) {
					<div class="file-question-overlay">
						<ion-spinner name="crescent" aria-hidden="true"></ion-spinner>

						<span class="file-question-overlay-status">{{ "FILE_QUESTION__UPLOADING" | transloco }}</span>
					</div>
				}

				<button
					type="button"
					class="file-question-selected-main"
					[disabled]="uploadBusy"
					(click)="onSelectedActivate(fileInput)"
				>
					<div class="file-question-thumb file-question-thumb-icon" aria-hidden="true">
						<ion-icon name="document-text-outline"></ion-icon>
					</div>

					<div class="file-question-meta">
						<span class="file-question-name">
							{{ fileName || ("FILE_QUESTION__FILE_ATTACHED" | transloco) }}
						</span>
						@if (fileSizeLabel) {
							<span class="file-question-size">{{ fileSizeLabel }}</span>
						}
					</div>
				</button>

				<button
					type="button"
					class="file-question-remove"
					[disabled]="uploadBusy"
					[attr.aria-label]="'FILE_QUESTION__REMOVE' | transloco"
					[attr.title]="'FILE_QUESTION__REMOVE' | transloco"
					(click)="onRemoveFile($event)"
				>
					<ion-icon name="close-outline" aria-hidden="true"></ion-icon>
				</button>
			</div>
		}

		<input
			#fileInput
			type="file"
			class="file-question-input"
			[accept]="accept"
			[disabled]="uploadBusy"
			(change)="pickFile($event)"
		/>
	</div>
</app-question-template>
